import React, { Component } from "react";
import img1 from "../img/Mask.png";
import salary from "../img/salary.png";
import client from "../img/client.png";
import hourglass from "../img/hourglass.png";
import "../css/nanny.css";
import HeaderLink from "../Headers/HeaderLink";
import { Button, Container, Navbar } from "reactstrap";
import { CgLock } from "react-icons/cg";
import { HiOutlinePhone } from "react-icons/hi";
import { BsFillArrowRightCircleFill } from "react-icons/bs";

export default function Step1({
  isOtpSend,
  verifyOtp,
  sendOtp,
  errors,
  handleChange,
  gotoMomKidCare,
  currentStep,
  resentOtp,
  mobile,
  secondsLeft,
  handleResetClick,
  isResendOtp,
}) {
  if (currentStep !== 1) {
    return null;
  }
  return (
    <>
      <HeaderLink gotoMomKidCare={gotoMomKidCare} />
      <div className="container  border-1">
        <div className="row mt-4 pt-5">
          <div className="col-lg-12 mt-lg-4">
            <div className="row">
              <div className="col-12 d-lg-none d-block pl-4">
                <h1
                  style={{
                    color: "#174D82",
                    fontFamily: "Montserrat, Medium",
                    fontSize: "15pt",
                  }}
                  className="ml-1 ml-lg-0"
                >
                  Babysitter/ Nanny/ Japa & Baby Mother Massage Jobs
                </h1>
              </div>

              <div className="col-lg-6 text-center">
                <img
                  src={img1}
                  width="330"
                  height="330"
                  className="d-lg-block d-none"
                  style={{ margin: "0px 120px" }}
                />
                <img
                  src={img1}
                  width="200"
                  height="200"
                  className="d-lg-none d-block mx-auto"
                />
              </div>

              <div className="col-lg-6 ">
                <div className="row m-2 mt-4">
                  <div className="col-lg-8 d-lg-block d-none">
                    <p
                      style={{
                        color: "#174D82",
                        fontFamily: "Montserrat, Medium",
                        fontSize: "15pt",
                        marginBottom: "0px",
                      }}
                    >
                      Babysitter/ Nanny/ Japa & Baby Mother Massage Jobs
                    </p>
                  </div>
                  <div className="col-lg-8" style={{ marginTop: "13px" }}>
                    <p
                      style={{
                        color: "#005495",
                        fontFamily: "Montserrat, Medium",
                        fontSize: "15px",
                        marginBottom: "0px",
                        marginTop: "5px",
                      }}
                    >
                      Provide your Phone Number to apply for the suitable Jobs
                      (only for Ladies)
                    </p>
                  </div>
                  <div className="col-lg-7">
                    <p
                      style={{
                        color: "#6B6B6B",
                        fontFamily: "Montserrat, Medium",
                        fontSize: "10pt",
                        marginBottom: "0px",
                        marginTop: "10px",
                      }}
                    >
                      उपयुक्त नौकरियों के लिए आवेदन करने के लिए कृपया अपना फोन
                      नंबर प्रदान करें (केवल महिलाओं के लिए)
                    </p>
                  </div>
                  {/* input */}
                  <form onSubmit={(e) => sendOtp(e)} className='pl-0' method='post'>
                    <div
                      className="col-lg-12 col-12"
                      style={{ marginTop: "25px" }}
                    >
                      <div
                        className="inp1"
                        style={{
                          backgroundColor: "#E8F4FF",
                          width: "280px",
                          border: errors.mobile && "2px solid red",
                        }}
                      >
                        <HiOutlinePhone
                          style={{ color: "#174D82" }}
                          size="20px"
                        />
                        <span>|</span>
                        <input
                          value={mobile}
                          type="text"
                          placeholder="Phone Number (मोबाइल नंबर)"
                          name="mobile"
                          onChange={handleChange}
                          style={{ fontSize: "14px", backgroundColor: "#E8F4FF" }}
                        />
                      </div>
                    </div>
                  </form>

                  {errors.mobile ? (
                    <span className="custom-error ml-2">{errors.mobile}</span>
                  ) : (
                    ""
                  )}

                  {isOtpSend ? (
                    <>
                      <form onSubmit={(e) => verifyOtp(e)} className='pl-0' method='post'>
                        <div
                          className="col-lg-12 col-12"
                          style={{ marginTop: "20px" }}
                        >
                          <div
                            className="inp1"
                            style={{
                              backgroundColor: "#E8F4FF",
                              width: "280px",
                              border: errors.isOtpValid && "2px solid red",
                            }}
                          >
                            <CgLock style={{ color: "#174D82" }} size="20px" />
                            <span>|</span>
                            <input
                              type="text"
                              placeholder="Verify OTP (ओटीपी सत्यापित करें )"
                              name="otp"
                              onChange={handleChange}
                              style={{
                                fontSize: "14px",
                                backgroundColor: "#E8F4FF",
                              }}
                            />
                          </div>
                        </div>
                      </form>
                      {errors.isOtpValid ? (
                        <div className="col-lg-4 col-6">
                          <p
                            style={{
                              color: "red",
                              fontSize: "11px",
                              fontFamily: "Montserrat, Medium",
                              marginTop: "20px",
                            }}
                          >
                            Incorrect OTP
                          </p>
                        </div>
                      ) : (
                        <div className="col-lg-4 col-6">
                          <p
                            style={{
                              color: "green",
                              fontSize: "11px",
                              fontFamily: "Montserrat, Medium",
                              marginTop: "20px",
                            }}
                          >
                            OTP Sent
                          </p>
                        </div>
                      )}
                      {isResendOtp ? (
                        <div
                          className="col-lg-4 col-6"
                          style={{
                            color: "grey",
                            fontSize: "11px",
                            fontFamily: "Montserrat, Medium",
                            marginTop: "20px",
                          }}
                        >
                          Resend OTP in 00:{secondsLeft}
                        </div>
                      ) : (
                        <div className="col-lg-4 col-6">
                          <p
                            style={{
                              color: "blue",
                              fontSize: "11px",
                              fontFamily: "Montserrat, Medium",
                              marginTop: "20px",
                              cursor: "pointer",
                            }}
                            onClick={() => resentOtp()}
                          >
                            Resend OTP{" "}
                            <BsFillArrowRightCircleFill
                              size="16
                            "
                            />
                          </p>
                        </div>
                      )}
                      <div className="col-lg-8">
                        <Button
                          className="float-left px-4 py-2"
                          id="nannyPostform"
                          style={{
                            backgroundColor: "#00A2FF",
                            border: 0,
                            fontSize: "12px",
                            paddingLeft: "20px",
                            color: "#fff",
                          }}
                          type="button"
                          onClick={(e) => verifyOtp(e)}
                        >
                          NEXT
                        </Button>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="col-lg-8 mt-4">
                        <Button
                          className="float-left px-4 py-2"
                          id='nannyPreform'
                          style={{
                            backgroundColor: "#00A2FF",
                            border: 0,
                            fontSize: "12px",
                            color: "#fff",
                          }}
                          type="button"
                          onClick={(e) => sendOtp(e)}
                        >
                          SEND OTP
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-lg-5 mt-3 pt-3 d-lg-none d-block">
              <div className="col-lg-12 text-lg-center">
                <p
                  style={{
                    color: "#005495",
                    fontFamily: "Montserrat, Medium",
                    marginBottom: "0px",
                    fontSize: "15px",
                  }}
                  className="ml-lg-0 ml-4"
                >
                  Get job in 48 hrs post verifications
                </p>
              </div>
              <div className="col-lg-12 mt-1 text-lg-center">
                <p
                  style={{
                    color: "#6B6B6B",
                    fontFamily: "Montserrat, Medium",
                    // width: "350pt",
                    marginBottom: "0px",
                    heigth: "10pt",
                    fontSize: "15px",
                  }}
                  className="ml-lg-0 ml-4"
                >
                  सत्यापन के बाद 48 घंटे में नौकरी पाएं
                </p>
              </div>
              <div className="col-lg-12 mt-1 text-lg-center">
                <p
                  style={{
                    color: "#6B6B6B",
                    fontFamily: "Montserrat, Medium",
                    fontSize: "10px",
                  }}
                  className="ml-lg-0 ml-4"
                >
                  हमारे साथ पंजीकरण से संबंधित अक्सर पूछे जाने वाले प्रश्न (FAQ) पढ़ने के लिए कृपया <a href="https://www.momkidcare.com/japa-nanny-jobs#carrierfaq" target="_blank" style={{ cursor: 'pointer' }}>यहां जाएं</a>
                </p>
              </div>
            </div>

            {/* DESKTOP Show Content */}
            <Navbar className="d-lg-block d-none" expand="md">
              <div className="row">
                <div className="col-lg-12 mt-lg-4 text-lg-center">
                  <p
                    style={{
                      color: "#005495",
                      fontFamily: "Montserrat, Medium",
                      marginBottom: "0px",
                      fontSize: "15px",
                    }}
                    className="ml-lg-0 ml-4"
                  >
                    Get job in 48 hrs post verifications
                  </p>
                </div>
                <div className="col-lg-12 mt-1 text-lg-center">
                  <p
                    style={{
                      color: "#6B6B6B",
                      fontFamily: "Montserrat, Medium",
                      // width: "350pt",
                      marginBottom: "0px",
                      heigth: "10pt",
                      fontSize: "15px",
                    }}
                    className="ml-lg-0 ml-4 mb-2"
                  >
                    सत्यापन के बाद 48 घंटे में नौकरी पाएं
                  </p>
                </div>
                <div className="col-lg-12 text-lg-center">
                  <p
                    style={{
                      color: "#6B6B6B",
                      fontFamily: "Montserrat, Medium",
                      fontSize: "10px",
                    }}
                    className="ml-lg-0 ml-4 mb-2"
                  >
                    हमारे साथ पंजीकरण से संबंधित अक्सर पूछे जाने वाले प्रश्न (FAQ) पढ़ने के लिए कृपया <a href="https://www.momkidcare.com/japa-nanny-jobs#carrierfaq" target="_blank" style={{ cursor: 'pointer' }}>यहां जाएं</a>
                  </p>
                </div>
              </div>
            </Navbar>

            <Container className="d-lg-block d-none" expand="md">
              <div className="row justify-content-center pt-1">
                <div className="col-lg-12 col-10 gra py-1 d-block">
                  <div className="row justify-content-center">
                    <div className="col-lg-3 ">
                      <div className="row align-items-center">
                        <div className="col-lg-2 p-4 col-2 text-lg-right">
                          <img src={client} width="35px" />
                        </div>
                        <div className="col-lg-6 col-6 ml-3">
                          <p
                            style={{
                              color: "#005495",
                              fontFamily: "Montserrat, Medium",
                              fontSize: "13px",
                              marginBottom: "0px",
                              lineHeight: "1.3",
                            }}
                          >
                            More than 5000 Potential Clients per Month
                          </p>
                        </div>
                        <p
                          style={{
                            borderLeft: "2px solid #0075FF",
                            marginTop: "20px",
                            height: "30px",
                            opacity: "21%",
                            marginLeft: "30px",
                          }}
                          className="d-lg-block d-none col"
                        ></p>
                        <p
                          style={{
                            borderBottom: "2px solid #0075FF",
                            marginTop: "5px",
                            width: "150px",
                            marginLeft: "85px",
                            opacity: "21%",
                          }}
                          className="d-lg-none d-block"
                        ></p>
                      </div>
                    </div>
                    <div className="col-lg-3 ">
                      <div className="row align-items-center">
                        <div className="col-lg-2 col-2 p-4 text-lg-right">
                          <img src={salary} width="38px" />
                        </div>
                        <div className="col-lg-6 col-6 ml-3 ">
                          <p
                            style={{
                              color: "#005495",
                              fontFamily: "Montserrat, Medium",
                              fontSize: "13px",
                              marginBottom: "0px",
                              lineHeight: "1.3",
                            }}
                          >
                            Average Salary &#62; Rs 22000 Month for
                            24 Hrs
                          </p>
                        </div>
                        <p
                          style={{
                            borderLeft: "2px solid #0075FF",
                            marginTop: "20px",
                            height: "30px",
                            opacity: "21%",
                            marginLeft: "40px",
                          }}
                          className="d-lg-block d-none col"
                        ></p>
                        <p
                          style={{
                            borderBottom: "2px solid #0075FF",
                            marginTop: "5px",
                            width: "150px",
                            marginLeft: "85px",
                            opacity: "21%",
                          }}
                          className="d-lg-none d-block"
                        ></p>
                      </div>
                    </div>
                    <div className="col-lg-3 ">
                      <div className="row align-items-center">
                        <div className="col-lg-2 p-4 col-2 text-lg-0">
                          <img src={hourglass} width="35px" />
                        </div>
                        <div className="col-lg-8 col-6 ml-4 ">
                          <p
                            style={{
                              color: "#005495",
                              fontFamily: "Montserrat, Medium",
                              fontSize: "13px",
                              marginBottom: "0px",
                            }}
                          >
                            Part time opportunity in Baby Mother Massage
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>

            {/* Show Only Mobile Screen */}
            <div className="row mt-lg-3 mt-1 justify-content-center mb-5 d-lg-none d-block d-flex">
              <div className="col-lg-12 col-10 gra py-1 d-lg-none d-block justify-content-center">
                <div className="row">
                  <div className="col-lg-3 ">
                    <div className="row align-items-center">
                      <div className="col-lg-2 p-4 col-2 text-lg-right">
                        <img src={client} width="45px" />
                      </div>
                      <div className="col-lg-6 col-6 ml-3">
                        <p
                          style={{
                            color: "#005495",
                            fontFamily: "Montserrat, Medium",
                            fontSize: "13px",
                            marginBottom: "0px",
                            lineHeight: "1.3",
                          }}
                        >
                          More than 5000 Potential Clients per Month
                        </p>
                      </div>
                      <p
                        style={{
                          borderLeft: "2px solid #0075FF",
                          marginTop: "20px",
                          height: "30px",
                          opacity: "21%",
                          marginLeft: "10px",
                        }}
                        className="d-lg-block d-none col"
                      ></p>
                      <p
                        style={{
                          borderBottom: "2px solid #0075FF",
                          marginTop: "5px",
                          width: "150px",
                          marginLeft: "85px",
                          opacity: "21%",
                        }}
                        className="d-lg-none d-block"
                      ></p>
                    </div>
                  </div>
                  <div className="col-lg-3 ">
                    <div className="row align-items-center">
                      <div className="col-lg-2 col-2 p-4 text-lg-right">
                        <img src={salary} width="45px" />
                      </div>
                      <div className="col-lg-6 col-6 ml-3 ">
                        <p
                          style={{
                            color: "#005495",
                            fontFamily: "Montserrat, Medium",
                            fontSize: "13px",
                            marginBottom: "0px",
                            lineHeight: "1.3",
                          }}
                        >
                          Average Salary <br /> &#62; Rs 22000 per Month for 24
                          Hrs
                        </p>
                      </div>
                      <p
                        style={{
                          borderLeft: "2px solid #0075FF",
                          marginTop: "20px",
                          height: "30px",
                          opacity: "21%",
                          marginLeft: "40px",
                        }}
                        className="d-lg-block d-none col"
                      ></p>
                      <p
                        style={{
                          borderBottom: "2px solid #0075FF",
                          marginTop: "5px",
                          width: "150px",
                          marginLeft: "85px",
                          opacity: "21%",
                        }}
                        className="d-lg-none d-block"
                      ></p>
                    </div>
                  </div>
                  <div className="col-lg-3 ">
                    <div className="row align-items-center">
                      <div className="col-lg-2 p-4 col-2 text-lg-0">
                        <img src={hourglass} width="45px" />
                      </div>
                      <div className="col-lg-6 col-6 ml-3 ">
                        <p
                          style={{
                            color: "#005495",
                            fontFamily: "Montserrat, Medium",
                            fontSize: "13px",
                            marginBottom: "0px",
                          }}
                        >
                          Part time opportunity in Baby Mother Massage
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
